import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {setMark} from '@eb/performance-monitor';

import ConnectedFeedBuilder from './ConnectedFeedBuilder';
import ConnectedLocationSearchAutocomplete from './ConnectedLocationSearchAutocomplete';

import {
    fetchEventsForTab,
    fetchEventsForYouTab,
} from '../redux/events/actions';

import {
    FEED_TABS,
    FOR_YOU,
    TABS_CONFIG,
} from '../constants/tabConfig';

import {
    EVENT_SEARCH_PROPTYPES,
} from '../constants/propTypes';

import {gettext} from '../translations';

import StickyTabs from '../components/StickyTabs';

import './BrowseContainer.scss';

const LOCATION_AUTOCOMPLETE_PROPS = {
    borderType: 'none',
    id: 'locationPicker',
    name: 'locationPicker',
    hideOutline: true,
    isLimitedSearch: true,
    preventInputValuePrefill: true,
    shouldRemoveConflictiveAria: true,
};

const getBrowseTabs = (shouldShowForYouTab) => {
    const tabs = FEED_TABS.map((tabKey, index) => {
        const {name, eventSearch, follow, feedConfig} = TABS_CONFIG[tabKey];

        return ({
            tabKey,
            value: index,
            displayName: name,
            content: (<ConnectedFeedBuilder feedConfig={feedConfig} eventSearch={eventSearch} follow={follow} />),
        });
    });

    if (!shouldShowForYouTab) {
        return tabs.filter((tab) => tab.tabKey !== FOR_YOU);
    }

    return tabs;
};

const getLocationComponent = () => (
    <div className="browse__location eds-l-pad-top-5">
        <div
            className="browse__location-text"
        >
            {gettext('Popular in ')}
        </div>
        <ConnectedLocationSearchAutocomplete
            autocompleteProps={LOCATION_AUTOCOMPLETE_PROPS}
            shouldDispatchSearchActions={true}
        />
    </div>
);

class Browse extends Component {
    static propTypes = {
        fetchEventsForTab: PropTypes.func,
        fetchEventsForYouTab: PropTypes.func,
        eventSearch: EVENT_SEARCH_PROPTYPES,
        isAuthenticated: PropTypes.bool,
        shouldShowForYouTab: PropTypes.bool,
    };

    componentDidMount() {
        setMark('feed-tabs-ready');
    }

    _handleTabChange = (tabIndex) => {
        const {
            fetchEventsForTab,
            fetchEventsForYouTab,
        } = this.props;

        document.querySelector('.browse-section').scrollIntoView({
            behavior: 'smooth',
        });

        const configKey = FEED_TABS[tabIndex];
        const fetchEvents = configKey === FOR_YOU ? fetchEventsForYouTab : fetchEventsForTab;

        fetchEvents({tabIndex});
    }

    render() {
        const {shouldShowForYouTab} = this.props;
        const items = getBrowseTabs(shouldShowForYouTab);
        const locationComponent = getLocationComponent();

        return (
            <div className="browse-section">
                {locationComponent}

                <StickyTabs
                    items={items}
                    onTabChange={this._handleTabChange}
                />
            </div>
        );
    }
}

const _mapStateToProps = (state) => ({
    isAuthenticated: state.user.isAuthenticated,
    shouldShowForYouTab: state.app.featureFlags.launchForYouTab,
});

const _mapDispatchToProps = {
    fetchEventsForTab,
    fetchEventsForYouTab,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(Browse);
